import {
  CaseTypesApiClient,
  createCaseTypesApiClient,
} from '@peritasai/data-access';
import type {
  CaseTypeDto,
  CaseTypesFilterParams,
  CreateCaseTypeDto,
  PaginatedCaseTypesResponseDto,
  UpdateCaseTypeDto,
} from '@peritasai/types';
import { CaseTypeEntity } from './case-type.entity';

export interface ICaseTypesRepository {
  getCaseTypesPaginated(
    options: CaseTypesFilterParams
  ): Promise<PaginatedCaseTypesResponseDto & { caseTypes: CaseTypeEntity[] }>;
  createCaseType(dto: CreateCaseTypeDto): Promise<CaseTypeEntity>;
  updateCaseType(id: string, dto: UpdateCaseTypeDto): Promise<CaseTypeEntity>;
}

export class CaseTypesRepository implements ICaseTypesRepository {
  constructor(private readonly apiClient: CaseTypesApiClient) {}

  async getCaseTypesPaginated(
    options: CaseTypesFilterParams = {}
  ): Promise<PaginatedCaseTypesResponseDto & { caseTypes: CaseTypeEntity[] }> {
    const response = await this.apiClient.getCaseTypes(options);
    return {
      ...response,
      caseTypes: response.data.map((dto) => this.toEntity(dto)),
    };
  }

  async createCaseType(dto: CreateCaseTypeDto): Promise<CaseTypeEntity> {
    const result = await this.apiClient.createCaseType(dto);
    return this.toEntity(result);
  }

  async updateCaseType(id: string, dto: UpdateCaseTypeDto): Promise<CaseTypeEntity> {
    const result = await this.apiClient.updateCaseType(id, dto);
    return this.toEntity(result);
  }

  private toEntity(dto: CaseTypeDto): CaseTypeEntity {
    return new CaseTypeEntity(dto);
  }
}

export const caseTypesRepository = new CaseTypesRepository(createCaseTypesApiClient());
